module.exports = __webpack_public_path__ + "img/logo-dne-exchange.4431ed19.svg";